import { useState, useEffect } from "react";
import { Col, Row, Alert, Modal, Form } from "react-bootstrap";
import '../css/Connect.css';

export const Connect = ({ status, message, onValidated }) => {
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        company: '',
        country: '',
        subscribe: true
    });

    useEffect(() => {
        if (status === 'success') {
            clearFields();
            setShowModal(false);
        }
    }, [status]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            onValidated(formData);
        }
    };

    const validateForm = () => {
        return formData.email.includes("@") &&
            formData.firstName &&
            formData.lastName &&
            formData.country;
    };

    const clearFields = () => {
        setFormData({
            firstName: '',
            lastName: '',
            email: '',
            currency: '',
            country: '',
            subscribe: true
        });
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    return (
        <section className="Connect" id="Connect">

            <div className="newsletter-bx">
                <Row className="align-items-center">
                    <Col lg={5} className="pe-lg-5">
                        <div className="cta-content">
                            <h3 className="cta-title">Start Your Influencer Journey</h3>
                            <ul className="value-props">
                                <li>
                                    <strong>Phone:</strong> <a href="tel:+11234567890">+1 (720) 800-6166</a>
                                </li>
                                <li>
                                    <strong>Email:</strong> <a href="mailto:info@company.com">info@clubcargomedia.com</a>
                                </li>
                                <li>
                                    <strong>Location:</strong>
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.840069005149!2d-122.419415684681!3d37.7749292797597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085808c7c14d3bb%3A0x0!2zMzfCsDQ2JzQ2LjAiTiAxMjLCsDI1JzA3LjkiVw!5e0!3m2!1sen!2sus!4v1600000000000!5m2!1sen!2sus"
                                        width="100%"
                                        height="200"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        title="Company Location"
                                    ></iframe>
                                </li>
                            </ul>
                        </div>
                    </Col>

                    <Col lg={7} className="text-center">
                        <div className="cta-wrapper">
                            <div className="decorative-line"></div>
                            <h4 className="cta-subtitle">Get Free Consultation</h4>
                            <button
                                className="custom-cta-btn"
                                onClick={() => setShowModal(true)}
                            >
                                <span className="btn-icon">✉️</span>
                                Connect with Experts
                            </button>
                            <p className="cta-note">
                                Typically responds within 2 business hours
                            </p>
                        </div>
                    </Col>
                </Row>
            </div>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                dialogClassName="custom-modal"
            >
                <Modal.Header closeButton className="custom-modal-header">
                    <Modal.Title className="modal-title">Get in Touch</Modal.Title>
                    {/* <p className="modal-subtitle">We'll respond within 24 hours</p> */}
                </Modal.Header>
                <Modal.Body className="custom-modal-body">
                    <Form onSubmit={handleSubmit}>
                        <Row className="g-3">
                            <Col md={6}>
                                <div className="form-group">
                                    <label>First Name</label>
                                    <Form.Control
                                        placeholder="John"
                                        value={formData.firstName}
                                        onChange={(e) => handleChange('firstName', e.target.value)}
                                        required
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="form-group">
                                    <label>Last Name</label>
                                    <Form.Control
                                        placeholder="Doe"
                                        value={formData.lastName}
                                        onChange={(e) => handleChange('lastName', e.target.value)}
                                        required
                                    />
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="form-group">
                                    <label>Email</label>
                                    <Form.Control
                                        type="email"
                                        placeholder="john@company.com"
                                        value={formData.email}
                                        onChange={(e) => handleChange('email', e.target.value)}
                                        required
                                    />
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="form-group">
                                    <label>Company</label>
                                    <Form.Control
                                        placeholder="Company Name"
                                        value={formData.company}
                                        onChange={(e) => handleChange('company', e.target.value)}
                                    />
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="form-group">
                                    <label>Country</label>
                                    <Form.Select
                                        value={formData.country}
                                        onChange={(e) => handleChange('country', e.target.value)}
                                        required
                                    >
                                        <option value="">Select Country</option>
                                        <option value="US">United States</option>
                                        <option value="UK">United Kingdom</option>
                                        <option value="CA">Canada</option>
                                    </Form.Select>
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="form-check">
                                    <Form.Check
                                        type="checkbox"
                                        id="subscribe-check"
                                        label="Subscribe to our influencer marketing newsletters"
                                        checked={formData.subscribe}
                                        onChange={(e) => handleChange('subscribe', e.target.checked)}
                                    />
                                </div>
                                {/* <div className="form-check">
                                            <Form.Check
                                                type="checkbox"
                                                id="subscribe-check"
                                                label="We may process your data to answer your inquiry"
                                                checked={formData.subscribe}
                                                onChange={(e) => handleChange('subscribe', e.target.checked)}
                                            />
                                        </div> */}
                                <p className="form-note">
                                    *We may process your data to answer your inquiry
                                </p>
                            </Col>
                        </Row>
                        <div className="text-center mt-4">
                            <button type="submit" className="gradient-btn">
                                Send Message
                            </button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {status === 'sending' && <Alert>Sending...</Alert>}
            {status === 'error' && <Alert variant="danger">{message}</Alert>}
            {status === 'success' && <Alert variant="success">{message}</Alert>}
        </section>
    );
};
